import Activity from '../activity';

type TActivitiesProps = {
  selectedLab: Array<ILabActivity>;
  setSelectedLab: React.Dispatch<React.SetStateAction<ILabActivity[]>>;
  data: Array<ILabActivity | ILabCertificate>;
};

const Activities = ({selectedLab, setSelectedLab, data}: TActivitiesProps) => {
  return (
    <>
      <div className="row" dir="ltr">
        {data?.map(item => (
          <Activity
            key={item.id}
            activity={item}
            selectedLab={selectedLab}
            setSelectedLab={setSelectedLab}
          />
        ))}
      </div>
    </>
  );
};

export default Activities;
